module.exports = __webpack_public_path__ + "static/media/gain_reduction_limit.e7063068.png";